import React from "react";
import Habit from "../components/Habit";
import { privateNavigationLinks } from "../utils/navigationLinks";
import NavbarScroller from "../components/Navbar";
import "../styles/pages/homepage.scss";

const Home: React.FC = () => {
  return (
    <div className="home">
      <NavbarScroller links={privateNavigationLinks.links} />
      <Habit />
    </div>
  );
};

export default Home;
